import { motion } from "framer-motion";

export default function ScrollCroc() {
  return (
    <div
      className="fixed -bottom-7 md:-bottom-10 left-3 md:left-6 z-[60] pointer-events-none"
      data-testid="croc-mascot"
      aria-hidden="true"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.2, type: "spring", stiffness: 55, damping: 12 }}
      >
        <motion.div
          animate={{ y: [0, -6, 0], rotate: [0, -2, 0] }}
          transition={{ duration: 1.7, repeat: Infinity, ease: "easeInOut" }}
        >
          <img
            src="/assets/mascot-croc.png"
            alt=""
            className="w-16 md:w-28 h-auto select-none"
            draggable="false"
          />
        </motion.div>
      </motion.div>
    </div>
  );
}
